import React, { Component } from 'react';
import facebookIcon from './../../images/common-static/icons/ic_facebook.svg';
import twitterIcon from './../../images/common-static/icons/ic_twitter.svg';
import newWindowIcon from './../../images/common-static/icons/ic_new-window.svg';

export default class Footer extends Component {
  render() {
    return (
      <footer className="footer">
        <div className="container">
          <div className="pure-g">
            <div className="pure-u-1 pure-u-sm-1-3 u-c">
              <h3>
                <a href="https://www.speedtest.net/">Speedtest<sup>®</sup></a>
              </h3>
              <ul className="menu-footer">
                <li><a href="/about/advertising">Advertise</a></li>
                <li><a href="/awards">Speedtest Awards<sup>™</sup></a></li>
                <li><a href="https://www.ookla.com/network">Speedtest Servers<sup>™</sup></a></li>
                <li><a href="/performance/united-states">Speedtest Performance Directory<sup>™</sup></a></li>
              </ul>
              <ul className="menu-footer social-links">
                <li>
                  <a href="https://twitter.com/speedtest" target="_blank" aria-label="Twitter - This link opens in a new tab">
                    <svg className="svg-icon svg-icon-larger">
                      <svg dangerouslySetInnerHTML={{ __html: twitterIcon }} />
                    </svg>
                    <sup>
                      <svg className="svg-icon">
                        <svg dangerouslySetInnerHTML={{ __html: newWindowIcon }} />
                      </svg>
                    </sup>
                  </a>
                  <a href="https://www.facebook.com/speedtest" target="_blank" aria-label="Facebook - This link opens in a new tab">
                    <svg className="svg-icon svg-icon-larger">
                      <svg dangerouslySetInnerHTML={{ __html: facebookIcon }} />
                    </svg>
                    <sup>
                      <svg className="svg-icon">
                        <svg dangerouslySetInnerHTML={{ __html: newWindowIcon }} />
                      </svg>
                    </sup>
                  </a>
                </li>
              </ul>
            </div>
            <div className="pure-u-1 pure-u-sm-1-3 u-c">
              <h3><a href="https://www.ziffdavis.com/">Ziff Davis</a></h3>
              <h3>Ookla® Brands</h3>
              <ul className="menu-footer">
                <li>
                  <a href="https://downdetector.com/" target="_blank">
                    Downdetector®&nbsp;
                    <sup>
                      <svg className="svg-icon" dangerouslySetInnerHTML={{ __html: newWindowIcon }} />
                    </sup>
                  </a>
                </li>
                <li>
                  <a href="https://www.ekahau.com/" target="_blank">
                    Ekahau®&nbsp;
                    <sup>
                      <svg className="svg-icon" dangerouslySetInnerHTML={{ __html: newWindowIcon }} />
                    </sup>
                  </a>
                </li>
                <li>
                  <a href="https://rootmetrics.com/" target="_blank">
                    RootMetrics®&nbsp;
                    <sup>
                      <svg className="svg-icon" dangerouslySetInnerHTML={{ __html: newWindowIcon }} />
                    </sup>
                  </a>
                </li>
              </ul>
            </div>
            <div className="pure-u-1 pure-u-sm-1-3 u-c">
              <h3><a href="/apps">Apps</a></h3>
              <ul className="menu-footer">
                <li><a href="/apps/android">Android</a></li>
                <li><a href="/apps/appletv">Apple TV</a></li>
                <li><a href="/apps/ios">iOS</a></li>
                <li><a href="/apps/mac">macOS</a></li>
                <li><a href="/apps/windows">Windows</a></li>
              </ul>
            </div>
          </div>
          <div className="pure-g">
            <div className="pure-u-1 u-c u-align-center">
              <p className="u-full-width-text u-smaller">
                © 2006-{new Date().getFullYear()} Ookla, LLC., a Ziff Davis company. All Rights Reserved. Ookla<sup>®</sup>, Speedtest<sup>®</sup>, and Speedtest Intelligence<sup>®</sup> are among the federally registered trademarks of Ookla, LLC and may only be used with explicit written permission.
              </p>
              <ul className="menu-footer menu-footer-sm menu-footer-inline u-align-center">
                <li>
                  <a href="https://www.speedtest.net/about/accessibility">Accessibility</a>
                </li>
                <li>
                  <a href="http://status.ookla.com/">Network Status</a>
                </li>
                <li>
                  <a href="https://www.speedtest.net/about/privacy">Privacy Policy</a>
                </li>
                <li>
                  <a href="https://www.speedtest.net/about/terms">Terms of Use</a>
                </li>
                <li>
                  <a href="https://www.speedtest.net/about/ccpa">Do Not Sell My Personal Information</a>
                </li>
              </ul>
              <div>
                <div id="teconsent" />
                <script
                  defer
                  src="//consent.truste.com/notice?domain=ziffdavis.com&c=teconsent&js=bb&noticeType=bb"
                  crossOrigin=""
                />
              </div>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}
